module.exports = __webpack_public_path__ + "media/images/icons/icon_search_small-de5ad6d9bbf532db3b1ed640ee47b296.svg";